import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Subject, map, takeUntil } from 'rxjs';
import { CustomerStateService } from 'src/services/customer-state.service';
import { PageLoadingService } from 'src/services/page-loading.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent  implements OnInit, OnDestroy {

  private readonly onDestroy$ = new Subject<void>();

  constructor(
    private router: Router, 
    private route: ActivatedRoute,
    public customerStateService: CustomerStateService,
    private loadingService: PageLoadingService
  ) { }


  async ngOnInit () {
  }

  isMyWashActive(): string{
    if(this.router.url.includes('upgrade') || this.router.url.includes('my-wash')){
      return 'active';
    } else {
      console.log("not active")
      return 'no';
    }
  }
  
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
